import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("Name is required."),
  country: Yup.object().required("Country is required."),
  defaultSize: Yup.object().required("Default Size is required."),
  contactPerson: Yup.string().required("Contact Person is required."),
  users: Yup.array()
    .of(
      Yup.object().shape({
        firstName: Yup.string().required("First Name is required."),
        lastName: Yup.string().required("Last Name is required."),
        username: Yup.string().required("Username is required."),
        email: Yup.string()
          .email("Email is invalid.")
          .required("Email is required.")
          .email("Email is invalid."),
        password: Yup.string()
          .required("Password is required.")
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
          ),
        confirmPassword: Yup.string()
          .required("Confirm password is required.")
          .oneOf([Yup.ref("password"), ""], "Passwords must match"),
      })
    )
    .min(1, "Need at least a Bank."),
});

export { validationSchema };
